export const MAX_LOG_LINES = 10000;
export const LOG_LEVELS = ['debug', 'info', 'warn', 'error'];

let nextLogId = 1;
let nextAuditId = 1;

const newLog = (entry) => ({ id: nextLogId++, ...entry });
const audit = (entry) => ({ id: nextAuditId++, ...entry });

export const createConsoleSlice = (set) => ({
  logs: [],
  consoleMode: null,
  throttleLimit: null,
  auditTrail: [],
  logFeedMode: 'demo',

  appendLogs: (entries) => set((state) => ({
    logs: [...state.logs, ...entries.map(newLog)].slice(-MAX_LOG_LINES)
  })),

  clearLogs: () => set({ logs: [] }),

  setLogFeedMode: (logFeedMode) => set({ logFeedMode }),

  addAuditEntry: (entry) => set((state) => ({
    auditTrail: [
      ...state.auditTrail,
      audit({ actor: 'Sarah Chen', timestamp: Date.now(), result: 'executed', ...entry })
    ].slice(-200)
  })),

  engageKillSwitch: () => set((state) => ({
    consoleMode: 'kill',
    agents: state.agents.map((agent) => ({ ...agent, status: 'idle', progress: 0 })),
    auditTrail: [
      ...state.auditTrail,
      audit({
        actor: 'Sarah Chen',
        action: 'emergency.kill_switch',
        detail: 'All agents forced idle — every running task aborted',
        timestamp: Date.now(),
        result: 'executed'
      })
    ]
  })),

  engageThrottle: (limit) => set((state) => ({
    consoleMode: 'throttle',
    throttleLimit: limit,
    auditTrail: [
      ...state.auditTrail,
      audit({
        actor: 'Sarah Chen',
        action: 'emergency.throttle',
        detail: `Concurrency capped at ${limit}%`,
        timestamp: Date.now(),
        result: 'executed'
      })
    ]
  })),

  engageSafeMode: () => set((state) => ({
    consoleMode: 'safe',
    agents: state.agents.map((agent) => (
      agent.status === 'autonomous' ? { ...agent, status: 'idle' } : agent
    )),
    auditTrail: [
      ...state.auditTrail,
      audit({
        actor: 'Sarah Chen',
        action: 'emergency.safe_mode',
        detail: 'Autonomy disabled — every action now requires approval',
        timestamp: Date.now(),
        result: 'executed'
      })
    ]
  })),

  disengageEmergency: () => set((state) => ({
    consoleMode: null,
    throttleLimit: null,
    auditTrail: [
      ...state.auditTrail,
      audit({
        actor: 'Sarah Chen',
        action: 'emergency.release',
        detail: 'Emergency controls released',
        timestamp: Date.now(),
        result: 'executed'
      })
    ]
  }))
});
